import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const COOKIE_KEY = 'COOKIE_KEY';

interface CookieState {
  open: boolean; // 初始cookie设置弹框状态
  preferenceCenterOpen: boolean; // Privacy Preference Center弹框状态
  config: Record<string, any>;
  preferences: {
    performance: boolean;
    targeting: boolean;
    functional: boolean;
    siteAnalytics: boolean;
  };
}

const initialState: CookieState = {
  open: false,
  preferenceCenterOpen: false,
  config: {},
  preferences: {
    performance: true, // 默认选中Performance Cookies
    targeting: false,
    functional: false,
    siteAnalytics: false
  }
};

export const cookieSlice = createSlice({
  name: 'cookie',
  initialState,
  reducers: {
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload;
    },
    setPreferenceCenterOpen: (state, action: PayloadAction<boolean>) => {
      state.preferenceCenterOpen = action.payload;
    },
    setCookieConfig: (state, action: PayloadAction<Record<string, any>>) => {
      state.config = action.payload;
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(COOKIE_KEY, 'true');
      }
      state.open = false;
    },
    initializeCookieState: (state) => {
      if (typeof window !== 'undefined') {
        state.open = window.localStorage.getItem(COOKIE_KEY) === null;
      }
    },
    updateCookiePreference: (
      state,
      action: PayloadAction<{ type: string; value: boolean }>
    ) => {
      const { type, value } = action.payload;
      if (type in state.preferences) {
        (state.preferences as any)[type] = value;
      }
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  setModalOpen,
  setPreferenceCenterOpen,
  setCookieConfig,
  initializeCookieState,
  updateCookiePreference
} = cookieSlice.actions;

export default cookieSlice.reducer;
